// KAN-899: the AfterSell cart drawer's quantity stepper changes only the Gift Bottle line, so a second
// bottle would carry no Engraving Fee. Keep the fee quantity equal to its bottle, as the theme drawer
// did through _gift_bottle_bundle_group. AfterSell reports every cart change on these events.
(() => {
  // A customer can reach Checkout before the fee catches up, and leaving the page cancels the update.
  const CHECKOUT_LINK = '.cart-internal-checkout-button__link';
  const QUANTITY_BUTTON = '.cart-internal-cart-items__qty-button';
  const CHECKOUT_HOLD_LIMIT_MS = 8000;

  let latestItems = null;
  let currentItems = [];
  let syncing = false;
  let lastQuantityClick = 0;
  let lastCartUpdate = 0;
  let checkoutHeld = false;

  const findMismatch = (items) => {
    for (const fee of items) {
      const group = fee.properties?._gift_bottle_bundle_group;
      if (!group || !fee.properties._is_engraving_fee) continue;
      const bottle = items.find((item) => (
        item.properties?._gift_bottle_bundle_group === group && !item.properties._is_engraving_fee
      ));
      if (bottle && bottle.quantity !== fee.quantity) return { key: fee.key, quantity: bottle.quantity };
    }
    return null;
  };

  const sync = async () => {
    if (syncing) return;
    syncing = true;
    try {
      let mismatch = latestItems && findMismatch(latestItems);
      while (mismatch) {
        latestItems = null;
        await window.aftersell.cart.actions.updateItemQuantity(mismatch.key, mismatch.quantity);
        mismatch = latestItems && findMismatch(latestItems);
      }
    } catch (error) {
      console.error('Gift Bottle fee sync failed', error);
    } finally {
      syncing = false;
    }
  };

  const onCartChange = (event) => {
    if (!event.detail?.items) return;
    latestItems = event.detail.items;
    currentItems = event.detail.items;
    lastCartUpdate = performance.now();
    sync();
  };

  const hasEngravedBottle = () => currentItems.some((item) => (
    item.properties?._gift_bottle_bundle_group && item.properties._is_engraving_fee
  ));

  const isFeeSettled = () => (
    !syncing && lastCartUpdate >= lastQuantityClick && !findMismatch(currentItems)
  );

  const holdCheckout = async (link) => {
    checkoutHeld = true;
    link.setAttribute('aria-busy', 'true');
    link.style.opacity = '0.6';
    const startedAt = performance.now();
    while (!isFeeSettled() && performance.now() - startedAt < CHECKOUT_HOLD_LIMIT_MS) {
      await new Promise((resolve) => setTimeout(resolve, 100));
    }
    link.removeAttribute('aria-busy');
    link.style.opacity = '';
    link.click();
    checkoutHeld = false;
  };

  window.addEventListener('click', (event) => {
    if (!hasEngravedBottle()) return;
    const path = event.composedPath().filter((node) => node instanceof Element);
    if (path.some((node) => node.matches(QUANTITY_BUTTON))) {
      lastQuantityClick = performance.now();
      return;
    }
    const link = path.find((node) => node.matches(CHECKOUT_LINK));
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey) return;
    if (checkoutHeld) {
      // holdCheckout's own click passes through once the fee is settled.
      if (isFeeSettled() || link.getAttribute('aria-busy') !== 'true') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    if (isFeeSettled()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    holdCheckout(link);
  }, { capture: true });

  window.addEventListener('aftersell:cart:cart-loaded', onCartChange);
  window.addEventListener('aftersell:cart:cart-updated', onCartChange);
})();
